import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteScenario = {
  name: "deleteScenario" as const,
  input: z.object({ scenarioId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
